import { Pipe, PipeTransform } from '@angular/core';
import { PERIOD_NAMES } from 'src/app/core/dictionaries/period-names';
import { PeriodEnum } from 'src/app/core/models/period';
import { formatPeriod } from 'src/app/core/utils/date-utils';

@Pipe({
  name: 'formatPeriod',
  standalone: false,
})
export class FormatPeriodPipe implements PipeTransform {
  public transform(
    period: PeriodEnum,
    start?: string | number | Date | null,
    end?: string | number | Date | null,
  ): string {
    return start || end ? formatPeriod(start, end) : PERIOD_NAMES[period];
  }
}
